const Sugar = {
    maps:'AIzaSyBNfYAV-Y9eKCgW0D8c5p3OTrjI1_PhgCg&q'
}

export default Sugar;